var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5643 8.25175C11.7771 8.25175 10.3246 9.70566 10.3246 11.4928C10.3246 13.2786 11.7771 14.7312 13.5643 14.7312C15.3514 14.7312 16.8053 13.2786 16.8053 11.4928C16.8053 9.70566 15.3514 8.25175 13.5643 8.25175ZM13.5628 16.7528C10.6644 16.7528 8.3075 14.3959 8.3075 11.4988C8.3075 8.60042 10.6644 6.24219 13.5628 6.24219C16.4612 6.24219 18.8194 8.60042 18.8194 11.4988C18.8194 14.3959 16.4612 16.7528 13.5628 16.7528Z",
    fill: "#EE7B30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3986_76708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.125732 0.679688H26.9999V22.3203H0.125732V0.679688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3986_76708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24101 11.4933C4.74033 17.0147 8.95021 20.2974 13.5686 20.2987C18.1869 20.2974 22.3968 17.0147 24.8961 11.4933C22.3968 5.97331 18.1869 2.6906 13.5686 2.68925C8.95155 2.6906 4.74033 5.97331 2.24101 11.4933ZM13.566 22.3213H13.5607H13.5593C8.00168 22.3173 3.0111 18.4218 0.208096 11.8981C0.0992545 11.6441 0.0992545 11.3566 0.208096 11.1026C3.0111 4.58017 8.00302 0.684726 13.5593 0.680695C13.562 0.679352 13.562 0.679352 13.5633 0.680695C13.566 0.679352 13.566 0.679352 13.5674 0.680695C19.125 0.684726 24.1156 4.58017 26.9186 11.1026C27.0288 11.3566 27.0288 11.6441 26.9186 11.8981C24.1169 18.4218 19.125 22.3173 13.5674 22.3213H13.566Z",
    fill: "#EE7B30"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.edb029b2aa7c386b54fcf33f840c61f4.svg";
export { ForwardRef as ReactComponent };